<div fxFlex fxLayout="column" class="home__layout">
  <!-- AVISO -->
  <!-- prueba push -->
  <div *ngIf="isWarning">
    <mat-card class="warning-card">
      <div cols="16" fxLayout="row" fxLayoutAlign="space-between">
        <div colspan="1">
          <mat-icon class="icon-ic_warning warning-icon"></mat-icon>
        </div>
        <div colspan="14" class="warning-content">
          <mat-card-title translate>home.warning</mat-card-title>
          <mat-card-content class="warning-text">
            <p translate>warning.description</p>
          </mat-card-content>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- HOLA NOMBRE -->
  <mat-card>
    <div cols="16" fxLayout="row" fxLayoutAlign="space-between stretch">
      <div colspan="8" fxLayout="column" fxLayoutAlign="space-around start">
        <h2 translate [translateParams]="{ userName: userName }">home.greeting</h2>
        <mat-card-content class="warning-text">
          <p translate>subtitle.home</p>
        </mat-card-content>
      </div>
      <div colspan="2"></div>
      <div colspan="3">
        <img alt="repsol" src="assets/img/img_repsol.png" class="home-image" *ngIf="isRepsol" ; margin:0px 50px />
        <img alt="Bonpreu" src="assets/img/img_logo_bonpreu.svg" class="home-image" *ngIf="isBonpreu" />
        <img alt="Mango" src="assets/img/img_logo_mango.svg" class="home-image" *ngIf="isMango" />
        <img
          alt="Renault"
          src="assets/img/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
          class="home-image"
          *ngIf="isRenault"
        />
        <img alt="Aural" src="assets/img/Aural.png" class="home-image home-image-Aural" *ngIf="isAural" />
        <img alt="Widex" src="assets/img/Aural.png" class="home-image home-image-Aural" *ngIf="isWidex" />
      </div>
    </div>
  </mat-card>

  <!-- ÚLTIMAS SOLICITUDES -->
  <mat-card class="lastrequest" *ngIf="agentDTOUser.typeUser !== 'A' && showRequestsCard">
    <h2 class="lastrequest__title" translate>home.latestRequests</h2>
    <mat-grid-list cols="12" rowHeight="80px" gutterSize="16px">
      <mat-grid-tile [colspan]="latestRequestCols" *ngFor="let element of buttonsList">
        <button
          fxFlex
          id="element.id"
          mat-stroked-button
          class="lastrequest__button"
          (click)="latestResquests(element)"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-chip
              fxFlex="0 0 60px"
              fxLayoutAlign="center center"
              class="lastrequest__circle {{ element.style }}"
              [ngClass]="{ 'lastrequest__num--small': element.requestsData.totalOperations > 999 }"
              (click)="latestResquests(element)"
            >
              {{ element.requestsData.totalOperations }}
            </mat-chip>

            <mat-label fxFlex translate class="lastrequest__label">{{ element.nameStatus }}</mat-label>
          </div>
        </button>
      </mat-grid-tile>
      <mat-grid-tile colspan="12">
        <button
          id="allRequestsButtonHome"
          mat-flat-button
          color="accent"
          fxFlex
          class="lastrequest__button-all"
          [innerHtml]="'home.allRequests' | translate"
          (click)="showAllRequests()"
        ></button>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card>

  <div fxFlex fxLayout="column" fxLayout.gt-xs="row wrap">
    <!-- CALCULADORA -->
    <!-- TODO: quitar el false cuando la pantalla sea definitiva -->
    <div *ngIf="false" [fxFlex]="gridSizes.calc.size[tamanho].width" [fxFlexOrder]="gridSizes.calc.size[tamanho].order">
      <mat-card fxFlex>
        <mat-card-title translate>home.calculator</mat-card-title>
        <mat-card-subtitle>calculator.description</mat-card-subtitle>
        <mat-card-content>
          <form (ngSubmit)="goToCalculator()" [formGroup]="calculatorForm">
            <mat-grid-list cols="10" rowHeight="76px">
              <mat-grid-tile colspan="4">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>pointOfSale.establishment</mat-label>
                  <!-- TODO: Implementar si fuese necesario el virtual scroll del cdk para temas de rendering -->
                  <mat-select
                    id="establishmentHome"
                    formControlName="establishment"
                    (selectionChange)="onChangeEstablishment()"
                  >
                    <mat-option *ngFor="let establishment of establishmentData" [value]="establishment.id">
                      {{ establishment.value }}
                    </mat-option>
                  </mat-select>
                  <!-- <mat-error *ngIf="calculatorForm.controls.establishment.hasError('required')" translate>
              field.required
            </mat-error> -->
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="4">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>home.requestedAmount</mat-label>
                  <input
                    #amountRequested
                    id="amountRequested"
                    formControlName="amountRequested"
                    matInput
                    (keypress)="numberOnly($event, amountRequested)"
                    (blur)="transformAmount($event, amountRequested)"
                    autocomplete="off"
                  />
                  <!-- <mat-error *ngIf="pointOfSaleDataForm.controls.idStoreMG.hasError('required')" translate>
              field.required
            </mat-error> -->
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="2">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>home.term</mat-label>
                  <input
                    #deadline
                    id="deadline"
                    formControlName="deadline"
                    matInput
                    (keypress)="numberOnly($event, deadline)"
                    autocomplete="off"
                  />
                  <!-- <mat-error *ngIf="pointOfSaleDataForm.controls.idStoreMG.hasError('required')" translate>
              field.required
            </mat-error> -->
                </mat-form-field>
              </mat-grid-tile>
              <br />
              <mat-grid-tile colspan="4">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>request.commercialProduct</mat-label>
                  <mat-select id="commercialProductHome" formControlName="commercialProduct">
                    <mat-option
                      *ngFor="let commercialProduct of commercialProductList"
                      [value]="commercialProduct.id"
                      >{{ commercialProduct.value }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="4">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>request.lineProduct</mat-label>
                  <mat-select id="lineProductHome" formControlName="lineProduct">
                    <mat-option *ngFor="let lineProduct of lineProductList" [value]="lineProduct.id">{{
                      lineProduct.value
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="2">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label translate>home.entrance</mat-label>
                  <input
                    #entrance
                    id="entrance"
                    formControlName="entrance"
                    matInput
                    (keypress)="numberOnly($event, entrance)"
                    (blur)="transformAmount($event, entrance)"
                    autocomplete="off"
                  />
                  <!-- <mat-error *ngIf="pointOfSaleDataForm.controls.idStoreMG.hasError('required')" translate>
              field.required
            </mat-error> -->
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="10">
                <div fxFlex="20" fxLayout="row" fxLayoutAlign="center center">
                  <button
                    id="buttonCalculateHome"
                    color="primary"
                    fxFlex="100"
                    mat-flat-button
                    [disabled]="!buttonEnabled || isLoading"
                  >
                    <mat-label translate>request.buttonCalculate</mat-label>
                  </button>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <div
      *ngIf="agentDTOUser.typeUser !== 'A' && showNewRequestCard"
      [fxFlex]="gridSizes.newRequest.size[tamanho].width"
      fxLayoutAlign="start stretch"
      fxLayout="column"
      [fxFlexOrder]="gridSizes.newRequest.size[tamanho].order"
      [class]="gridSizes.search.size[tamanho].layout"
    >
      <!-- ALTA SOLICITUD -->
      <mat-card class="new-request-card">
        <button
          id="newRequestButtonHome"
          class="new-request-card__button"
          (click)="redirectToNewRequest()"
          mat-flat-button
          fxFlex="100%"
        >
          <div fxFlex fxLayoutAlign="start center">
            <mat-icon
              class="icon-ic_list_edit new-request-logo"
              color="accent"
              fxFlex="64px"
              fxLayoutAlign="center center"
            ></mat-icon>
            <div fxFlex fxLayout="column" fxLayoutAlign="center start">
              <h2 translate>home.newRequest</h2>
              <p class="new-request-p" translate>home.newRequestForm</p>
            </div>
            <mat-icon class="icon-ic_chevron_right card-chevron" fxFlex="32px" fxLayoutAlign="center center"></mat-icon>
          </div>
        </button>
      </mat-card>
    </div>

    <div
      *ngIf="canSearchOperations"
      [fxFlex]="gridSizes.search.size[tamanho].width"
      [fxFlexOrder]="gridSizes.search.size[tamanho].order"
      [class]="gridSizes.search.size[tamanho].layout"
    >
      <!-- BUSCADOR -->
      <mat-card class="search-card">
        <h2 translate>home.search</h2>
        <p translate>home.find</p>
        <mat-card-content>
          <form (ngSubmit)="searchRequest()" [formGroup]="searchForm">
            <div class="search-card__wrapper">
              <div class="search-card__fields">
                <div class="search-card__field-number">
                  <mat-form-field fxFlex="100%" appearance="outline">
                    <mat-label translate>home.requestNumber</mat-label>
                    <input
                      #requestNumber
                      id="requestNumber"
                      formControlName="requestNumber"
                      matInput
                      (keypress)="numberOnlySearch($event, requestNumber)"
                      autocomplete="off"
                    />
                    <!-- <mat-error *ngIf="pointOfSaleDataForm.controls.idStoreMG.hasError('required')" translate>
                    field.required
                  </mat-error> -->
                  </mat-form-field>
                </div>

                <div class="search-card__field-nif">
                  <mat-form-field fxFlex="100%" appearance="outline">
                    <mat-label translate>search.input.documentId</mat-label>
                    <input id="searchNifHome" formControlName="searchNif" maxlength="9" matInput autocomplete="off" />
                    <!-- <mat-error *ngIf="pointOfSaleDataForm.controls.idStoreMG.hasError('required')" translate>
                    field.required
                  </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

              <div class="search-card__button">
                <button
                  id="searchButtonHome"
                  color="primary"
                  mat-flat-button
                  type="submit"
                  [disabled]="!searchButtonEnabled || isLoading"
                >
                  <mat-label translate>home.searchButton</mat-label>
                </button>
              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- FOTO2 -->
  <!-- <mat-card> </mat-card> -->
</div>
